export default function() {
  return new Worker(__webpack_public_path__ + "static/js/worker.b8755c0d.worker.js");
}
